<template>
  <nv-page header="Rules List">
    <template slot="toolbar">
      <status-changer-btn v-model="editMode" />
      <v-spacer />
      <nv-table-search ref="search" v-model="search" />
    </template>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :options.sync="table"
      :server-items-length="totalItems"
      :footer-props="footerProps"
      :items-per-page.sync="table.itemsPerPage"
      class="elevation-1"
      must-sort
    >
      <template #item="{ item }">
        <tr>
          <td>{{ item.pattern }}</td>
          <td>{{ item.match_subdomains | formatMatch }}</td>
          <td>{{ item.ddrs_entity && item.ddrs_entity.name }}</td>
          <td>{{ item.ddrs_entity && item.ddrs_entity.client_id }}</td>
          <td>{{ item.v60_client && item.v60_client.id }}</td>
          <td>{{ item.ddrs_entity && item.ddrs_entity.vc_id }}</td>
          <td>
            <status-changer
              v-model="item.status"
              :update-url="`/rules/${item.id}`"
              :edit-mode="editMode"
            />
          </td>
          <td class="text-right">
            <v-btn
              v-if="$auth.hasPermissions('bee.mappings')"
              icon
              data-cy="edit-button"
              @click="openEdit(item)"
            >
              <v-icon class="text-right">mdi-pencil</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <edit-form v-model="form.show" :editing="form.edit" @saved="tableFetch" />
  </nv-page>
</template>

<script>
import HTTP from '@/api/bee';
import { TableMixin } from '@nielsen-media/ui-toolkit-vue-api';
import StatusChangerBtn from '@/components/StatusChangerBtn.vue';
import StatusChanger from '@/components/StatusChanger';
import EditForm from '@/components/rules/EditForm';
import { formatMatch } from '@/helpers/filters';

const headers = [
  { text: 'Rule', align: 'left', sortable: false, value: 'rule' },
  { text: 'Match Subdomains', align: 'left', sortable: false, value: 'match_subdomains' },
  { text: 'Name', align: 'left', sortable: false, value: 'name' },
  { text: 'Client ID', align: 'left', sortable: false, value: 'ddrs' },
  { text: 'V60', align: 'left', sortable: false, value: 'v60' },
  { text: 'Sub-brand', align: 'left', sortable: false, value: 'c6' },
  { text: 'Status', align: 'left', sortable: false, value: 'status' },
  { text: '', align: 'right', sortable: false, value: 'action' },
];

export default {
  components: { EditForm, StatusChanger, StatusChangerBtn },
  filters: { formatMatch },
  mixins: [TableMixin],
  data: () => ({
    headers,
    editMode: false,
    form: {
      show: false,
      edit: null,
    },
    table: { sortBy: ['pattern'], sortDesc: [false] },
    tableFilters: { status: 'active' },
  }),
  methods: {
    tableFetch() {
      this.paginateTableData(HTTP, `/rules`);
    },
    openEdit(item = null) {
      this.form.edit = item;
      this.form.show = true;
    },
  },
};
</script>
